import { render } from "./DevelopersDocs.vue?vue&type=template&id=6959f7da"
import script from "./DevelopersDocs.vue?vue&type=script&lang=js"
export * from "./DevelopersDocs.vue?vue&type=script&lang=js"

import "./DevelopersDocs.vue?vue&type=style&index=0&id=6959f7da&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__